<template>
    <v-card-actions class="pb-4">
        <slot name="pre"></slot>

        <v-btn
            v-if   = "showDelete"
            class  = "dialog-button mr-1"
            @click = "onDelete"
            depressed
        >
            {{ deleteLabel }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
            v-if   = "showCancel"
            class  = "dialog-button mr-0"
            @click = "onCancel"
            depressed
        >
            {{ $t('common.cancel') }}
        </v-btn>
        <v-btn
            v-if   = "showSave"
            class  = "dialog-button primary pl-3 pr-3"
            @click = "onSave"
            depressed
        >
            {{ storeLabel }}
        </v-btn>
    </v-card-actions>
</template>

<script>
export default {
    name: "FDialogActions",

    props: {
        storeLabel: {
            required: false,
            type    : String,
            default : function () {
                return this.$t('common.store');
            }
        },

        deleteLabel: {
            required: false,
            type    : String,
            default : function () {
                return this.$t('common.delete');
            }
        },


        showDelete: {
            required: false,
            type    : Boolean,
            default : function () {
                return false;
            }
        },

        showSave: {
            required: false,
            type    : Boolean,
            default : function () {
                return true;
            }
        },

        showCancel: {
            required: false,
            type    : Boolean,
            default : function () {
                return true;
            }
        },
    },

    methods: {
        onCancel () {
            this.$emit("cancel");
        },

        onSave () {
            this.$emit("store");
        },

        onDelete () {
            this.$emit("delete");
        }
    }
}
</script>

<style scoped>

</style>